const LAWYER_HOURLY_RATE = 502;
const LAWYER_HOURLY_RATE_SOURCE =
  'National Law Journal and ALM Legal Intelligence, Attorney Compensation Flash Survey (2026)';

export { LAWYER_HOURLY_RATE, LAWYER_HOURLY_RATE_SOURCE };
